import { render, staticRenderFns } from "./RoadSurfaceTab.vue?vue&type=template&id=1137bc08&scoped=true"
import script from "./RoadSurfaceTab.vue?vue&type=script&lang=ts"
export * from "./RoadSurfaceTab.vue?vue&type=script&lang=ts"
import style0 from "./RoadSurfaceTab.vue?vue&type=style&index=0&id=1137bc08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1137bc08",
  null
  
)

export default component.exports